import React from "react";
import Register from "../components/Authentication/Register"
export default function SignUp() {
  
  return (
    <Register />
  );
}
